import { useFullscreen } from "../../../contexts/FullScreenContext";
import { useDashboardDomainContext } from "../../../DashboardDomainProvider";
import { CardTileBody } from "./CardTiles/CardTileBody";
import { CardTileHeader } from "./CardTiles/CardTileHeader";
import { useRealtimeVisualData } from "../../charts/useRealtimeVisualData";

const FullscreenOverlay = ({ card }) => {
    const { closeFullscreen } = useFullscreen();
    const { getVisualFromCard} = useDashboardDomainContext();
    const visual = getVisualFromCard(card);
    const runtime = useRealtimeVisualData({ visual });



    if (!visual) 
        return <div className="card-tile-body empty" />;

    return (
        <div className="overlay" onClick={closeFullscreen}>
            {card &&
                <div className={`card-cell card-overlay`} onClick={(e) => e.stopPropagation()}>
                    <div className={'inner'}>
                        <CardTileHeader isOverlay={true} card={card} visual={visual} runtime={runtime} />
                        <CardTileBody card={card} visual={visual} runtime={runtime} />
                    </div>
                </div>
            }
        </div >
    );
};

export default FullscreenOverlay;
